module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="search-expired text-center">\n	<h1><i class="fa fa-clock-o"></i></h1>\n	<h2>'+
((__t=( t('search_expired') ))==null?'':__t)+
'</h2>\n	<p>'+
((__t=( t('search_expired_message') ))==null?'':__t)+
'</p>\n</div>';
}
return __p;
};
